import { Button } from "antd"
import React from "react"
import AppleSignin from "react-apple-signin-auth"
import { useTranslation } from "react-i18next"

import Images from "../../../Images"

interface AppleSocialProvidersProps {
  loading?: boolean
}

export function AppleSocialProviders({ loading }: AppleSocialProvidersProps) {
  const { t } = useTranslation()

  const clientId = import.meta.env.VITE_APP_APPLE_CLIENT_ID

  if (!clientId) return null

  const onSuccess = (response: any) => {
    // {
    //   "code": "c2b998caeb09d4d4cba68a9bfeb02dacd.0.pzyu.l6-kx53Hr6d5ETmUIAmjZg",
    //     "id_token": "eyJraWQiOiJIdlZJNkVzWlhKIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLmV6YnVpbGQud2ViIiwiZXhwIjoxNzYxMzE4NTk4LCJpYXQiOjE3NjEyMzIxOTgsInN1YiI6IjAwMDk4NC5lM2JhNGFiODVkMDE0ZTJlODVhZmVlYmMyZDdjZThiZC4xNTA5Iiwibm9uY2UiOiJub25jZSIsImNfaGFzaCI6InRmNnZKQUdjeEdKajZNWFRKTXlrMkEiLCJlbWFpbCI6IjhrY3dndmRqY2NAcHJpdmF0ZXJlbGF5LmFwcGxlaWQuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImF1dGhfdGltZSI6MTc2MTIzMjE5OCwibm9uY2Vfc3VwcG9ydGVkIjp0cnVlfQ.R7Xjm9bGJC_XI1imUpEiwQBoUisjsUBFHGFDK9aHng38EIUcVExmbh69LVzsWgnMBwxBVkL4HW_D0p7jyHXt6uFl-EQZLW86HMWknAOAwBwZHAglLma8AtTAAry__eZJ-BAYml1h7I0zGz0-OazGAXKkvhTkKPZ_RtLnTfKjXs17XGXaEzi4wWtz2xUURIVGlYx07RmncB6OWWhI5zoYjD_3Ou5kcTenWGmS2_Fo3FkA3yRInpAtpLDZcURgqf-VY2hkEm2qocrEIg0_BzOXa0zhCiZug2SMGMt8PuqBq3pN2fslWi5cWe-ubuSy0ZScT5pMXYVEHzVTPtFK_parJw",
    //     "state": "state"
    // },
    //   "user": {
    //   "name": {
    //     "firstName": "Ksenia",
    //       "lastName": "Taran"
    //   },
    //   "email": "8kcwgvdjcc@privaterelay.appleid.com"
    // }
    console.log("response", response)
  }

  const onError = (response: any) => {
    console.log("response", response)
  }

  return (
    <AppleSignin
      uiType={"light"}
      authOptions={{
        clientId,
        scope: "email name",
        redirectURI: "https://dev.ezbuild.dataforest.tech/sign-up",
        state: "state",
        nonce: "nonce",
        usePopup: true
      }}
      className="apple-auth-btn"
      noDefaultStyle={true}
      onSuccess={onSuccess}
      onError={onError}
      skipScript={false}
      render={(renderProps: any) => (
        <Button
          onClick={renderProps.onClick}
          size="large"
          className="social-provider-button"
          disabled={loading}
        >
          <div className="flex items-center gap-3 justify-center">
            <img src={Images.apple} alt={`apple-icon`} className="w-5 h-5" />
            <span>{t("Continue with Apple")}</span>
          </div>
        </Button>
      )}
    />
  )
}
